module.exports = __webpack_public_path__ + "static/media/position.2ceaf661.svg";